import axios from "axios"
import { envF } from "../../../env";
import renderGlobalAlert from "../../../system/hooks/useGlobalAlert";
import { IExportDocumentDTO } from "../../coreapi-dto/dirs/exportDocument";

export const exportDocumentRequest = async (idToolsGlobal: string, nameFile: string, dto: IExportDocumentDTO) => {
    const jwtToken = localStorage.getItem("TokenData") as string;
    const token = `Bearer ${JSON.parse(jwtToken).accessToken}`;

    const generateRequestUrl = (prefix: string, endPoint?: string) => {
        if (endPoint) {
            return `${envF.REACT_APP_API_GATEWAY_PATH}/${prefix}/${endPoint}`
        } else {
            return `${envF.REACT_APP_API_GATEWAY_PATH}/${prefix}`
        }
    }

    await axios.post(
        generateRequestUrl('ExportDocumentTools', idToolsGlobal),
        dto,
        {
            responseType: 'blob',
            headers: {
                Authorization: token
            },
        }
    ).then((e) => {
        if (e.status === 200) {
            const contentType = typeof e.headers['content-type'] === 'string' ? e.headers['content-type'] : undefined;
            const blob = new Blob([e.data], { type: contentType });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            
            // Определяем расширение файла на основе content-type
            let fileExtension = '.dbf'; // значение по умолчанию
            if (contentType === 'application/zip' || contentType === 'application/x-zip-compressed') {
                fileExtension = '.zip';
            }

            console.log('fileExtension',fileExtension,'contentType',contentType)
            
            link.download = `${nameFile}${fileExtension}`;
            document.body.appendChild(link);
            link.click();
            
            // Очистка
            setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }, 100);
        }
    }).catch((ex) => {
        renderGlobalAlert({
            variant: "exception",
            title: JSON.parse(ex.response.data.title).title,
            detail: ex.response.data.detail,
            statusCode: 500,
        });
    })
}